import Navbar from '@/components/feature/Navbar';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import HeroSection from './components/HeroSection';
import ContactMethods from './components/ContactMethods';
import CTASection from './components/CTASection';
import HowWorkGoes from './components/HowWorkGoes';
import WhyChooseUs from './components/WhyChooseUs';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

export default function ContactsPage() {
  const navLinks = [
    { label: 'Способы связи', target: 'contact-methods' },
    { label: 'Оставить заявку', target: 'contact-form' },
    { label: 'FAQ', target: 'faq' },
  ];

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      
      <SeoTitle title="Контакты | Business Training" />
      <PageJsonLd />
      <Navbar
        links={navLinks}
        ctaLabel="Заказать тренинг"
        ctaTarget="contact-form"
      />
      <HeroSection />
      <ContactMethods />
      <CTASection />
      <HowWorkGoes />
      <WhyChooseUs />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}